const isNil = (value) => {
  return typeof value === "undefined" || value === null;
};
const unpreferredNull = null;
const replaceNull = (input) => input === unpreferredNull ? void 0 : input;
const replaceUndefined = (input) => input === void 0 ? unpreferredNull : input;
export {
  isNil,
  replaceNull,
  replaceUndefined,
  unpreferredNull
};
//# sourceMappingURL=null.mjs.map
